/**
 * 已批准词汇（旧 views/dynamic-lexemes/ApprovedView.vue）：只读列表
 */
import { useEffect } from 'react'
import { App, Button, Card, Table, Tag, type TableColumnsType } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import { PageHeader } from '@/components/PageHeader'
import { formatDateTime } from '@/utils/datetime'
import { DynamicLexemeStatus, type DynamicLexeme } from '@/types/dynamic-lexemes'
import { useLexemeReviewList } from './hooks'

const columns: TableColumnsType<DynamicLexeme> = [
  { title: '词汇', key: 'word', width: 120, render: (_, record) => <Tag color="green">{record.word}</Tag> },
  { title: '语言', dataIndex: 'language', width: 80 },
  {
    title: '状态',
    key: 'status',
    width: 100,
    render: (_, record) => {
      const isAuto = record.metadata.status === DynamicLexemeStatus.AUTO_APPROVED
      return <Tag color={isAuto ? 'blue' : 'green'}>{isAuto ? '自动批准' : '手动批准'}</Tag>
    }
  },
  { title: '遇到次数', dataIndex: ['metadata', 'encounter_count'], width: 100 },
  {
    title: '审核者',
    key: 'reviewer',
    width: 120,
    render: (_, record) => (record.metadata.reviewed_by ? `管理员 ${record.metadata.reviewed_by}` : '系统自动')
  },
  {
    title: '审核时间',
    key: 'reviewed_at',
    width: 150,
    render: (_, record) => (record.metadata.reviewed_at ? formatDateTime(record.metadata.reviewed_at) : '--')
  }
]

export function ApprovedPage() {
  const { message } = App.useApp()
  const { data: lexemes = [], isFetching, isError, refetch } = useLexemeReviewList(100, DynamicLexemeStatus.APPROVED)

  useEffect(() => {
    if (isError) message.error('获取已批准词汇失败')
  }, [isError, message])

  const refresh = async () => {
    const result = await refetch()
    if (!result.isError) message.success('数据已刷新')
  }

  return (
    <div>
      <PageHeader title="已批准词汇" subtitle="查看已通过审核的动态词汇" />

      <Card
        title="已批准词汇列表"
        extra={
          <Button icon={<ReloadOutlined />} onClick={() => void refresh()}>
            刷新
          </Button>
        }
      >
        <Table<DynamicLexeme>
          rowKey="lexeme_id"
          columns={columns}
          dataSource={lexemes}
          loading={isFetching}
          pagination={{ pageSize: 20, showSizeChanger: true }}
        />
      </Card>
    </div>
  )
}
